import { useEffect } from "react";
import { authClient } from "@/lib/auth";
import { classifySession, redirectToLogin, sessionErrorStatus } from "@/lib/sessionAvailability";

/**
 * beforeLoad only runs on navigation. When the session expires while a list stays
 * open, send the user to login instead of leaving a page whose actions 401.
 */
export function RedirectWhenSignedOut() {
    const { data, isPending, error } = authClient.useSession();
    const availability = classifySession({
        user: data?.user ?? null,
        isPending,
        hasError: error != null,
        errorStatus: sessionErrorStatus(error),
    });

    useEffect(() => {
        if (availability === "signed-out") {
            redirectToLogin();
        }
    }, [availability]);

    return null;
}
